import {AbstractDelete} from "../../../clone/dialog/delete";
import {nsRuleset} from "../nsRuleset";

export {template} from "../../../clone/dialog/delete";

export class viewModel extends AbstractDelete {

    protected readonly EVENT_SUCCESS : string = "ruleset.delete.success";

    protected override process(): Promise<any> {
        return nsRuleset.trash(this.params.item);
    }

}
